// Copyright (c) 2023 WiseTime. All rights reserved.

import { SitePermission } from "../generated/legebill/site/membership/v4/membership_pb"

export const hasPermission = (
  permissionToCheck: SitePermission,
  permissions: SitePermission[],
): boolean => permissions.some(permission => permission === permissionToCheck)

